<template>
    <section class="collections view">
        <Header @toggleModal="toggleOpenDialog" @toggleModalSubscribe="toggleOpenSubscribe"/>
        <Banner />

        <!--
        <div class="titleCollectionsPage">
            <div class="collection-tabs" v-if="plansWeflix.length == 0 && userPortalWeflix">
                <button 
                    :class="['tab-button', { active: activeTab === 'all' }]"
                    @click="setActiveTab('all')"
                >
                    Todas as coleções
                </button>
                <button 
                    :class="['tab-button', { active: activeTab === 'owned' }]"
                    @click="setActiveTab('owned')"
                >
                    Minhas coleções
                </button>
                <button 
                    :class="['tab-button', { active: activeTab === 'available' }]"
                    @click="setActiveTab('available')"
                >
                    Coleções disponíveis
                </button>
            </div>
        </div>
        -->

        <!-- Loader -->
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>

        <!-- Container principal das coleções -->
        <div class="layout-netflix" v-if="urlBand || finalWebsite.typeImageCoverCourse == 2 || finalWebsite.typeImageCoverCourse == null">
            <div class="itensCollections" v-for="collection in filteredCollections" :key="collection.id">
                <div class="titleCollections pageCollections titleCollectionMobile">
                    <div class="info_header_collections">
                        <h3>{{collection.comercialName}}</h3>
                        <h5> <span v-if="collection.price"> 
                            R$ <strong>{{Number(collection.price).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</strong> 
                            ou <strong>{{collection.installment}}x de R$ {{Number(collection.price/collection.installment).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</strong>
                        </span></h5>
                        <p style="margin-bottom: 0px;">{{ collection.lessonQty || 0 }}
                             {{ (collection.lessonQty || 0) > 1 ? 'Vídeos' : 'Vídeo' }} 
                             | Duração: {{ formatarTempo(collection.lessonTime || 0) }}
                            
                            </p>
                        <!-- <small class="description-collections">{{collection.shortDescription?.replace(/<[^>]*>/g, '')}}</small>            -->
                    </div>
                    <div class="button-header-collections">
                        <button class="btn-collection" @click="handleCollectionClick(collection)">Ver coleção</button>
                        <button class="btn-collection" @click="redirectToCheckout(collection)" v-if="collection.price">Comprar</button>
                        <button 
                            class="btn-collection" 
                            @click="()=>{this.$router.push('/planos')}" 
                            v-if="!collection.price && (!userPortalWeflix || (userPortalWeflix && userPortalWeflix.user.orderStatus != 1))"
                        >
                            Assinar
                        </button>
                    </div>
                </div>
                <div class="videoCollections pageCollections">
                    <div class="itensVideoCollections">
                        <swiper
                            :modules="modules"
                            :slides-per-view="mobile ? 2 : 6"
                            :space-between="10"
                            navigation
                            @swiper="onSwiper"
                            @slideChange="onSlideChange"
                        >
                            <swiper-slide v-for="slide in collection.lessons" :key="slide.id">
                                
                                <div class="carousel__item" @click="GoToPlayer(slide, collection)">

                                <img v-if="!slide.finalVideoThumbnail" src="@/assets/Weflix/default-video-thumbnail.jpg" alt="Imagem padrão" class="thumbnail">
                                <img v-else :src="slide.finalVideoThumbnail" :alt="slide.title" class="thumbnail"/>
                                <!-- <img src="@/assets/gif/LOVEDEATHROBOTSVOLUME4_OfficialTeaser_Netflix-ezgif.com-video-to-gif-converter.gif" alt="GIF" class="gif-indicator"> -->
                                <div class="titleVideoCollections">
                                    <h3>{{slide.title}}</h3>
                                </div>

                                    <div class="lockIcon" v-if="userPortalWeflix && slide.sample !== 1 && userPortalWeflix.user.orderStatus != 1 && collection.owned != 4">
                                        <fa icon="lock" class="lockIcon"/>
                                        <span class="textPrivateVideo">Conteúdo Exclusivo</span>
                                    </div>

                                    <div class="lockBlock" v-if="!userPortalWeflix && slide.sample !== 1 && userPortalWeflix && (userPortalWeflix.user.orderStatus != 1 || userPortalWeflix.user.orderStatus != 4)">
                                        <fa icon="lock" class="lockIcon" />
                                        <span class="textPrivateVideo">Conteúdo Exclusivo</span>
                                    </div>

                                    <div class="sampleFlag" v-if="slide.sample === 1">
                                        <span>DEGUSTAÇÃO</span>
                                    </div>

                                    <!-- <div class="degradeCarousel__item"></div> -->
                                    <div class="descriptionVideo" v-if="finalWebsite.visibleTitleCourse == 1">
                                        <h4>{{slide.title}}</h4>
                                        <div class="videoInfo">
                                            <small>{{formatarTempo(slide.videoTime)}}</small>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                </div>
        </div>

        <!-- Paginação -->
        <div class="pagination site-collections">
            <button 
                :disabled="currentPage === 1" 
                @click="previousPage"
                class="pagination-button"
            >
                Anterior
            </button>
            
            <span class="page-info">Página {{currentPage}} de {{totalPages}}</span>
            
            <button 
                :disabled="currentPage === totalPages" 
                @click="nextPage"
                class="pagination-button"
            >
                Próximo
            </button>
        </div>

        <!-- Modal de Aviso -->
        <div v-if="showPurchaseModal" class="purchase-modal">
            <div class="modal-content">
                <h3>Conteúdo Exclusivo</h3>
                <p>Para acessar este conteúdo, você precisa adquirir esta coleção.</p>
                <small v-if="!userPortalWeflix">Realize o login ou cadastre-se para finalizar a compra.</small>
                <div class="modal-buttons">
                    <button @click="closePurchaseModal" class="cancel-button">Fechar</button>
                    <button @click="redirectToCheckout" class="buy-button">Comprar Agora</button>
                </div>
            </div>
        </div>

        <Footer/>
    </section>
    <Subscribe :show="openDialogSubscribe" @toggleModal="toggleOpenSubscribe"/>
    <Login :show="openDialogLogin" @toggleModal="toggleOpenDialog"/>
</template>

<script>
import { Carousel, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import Header from "@/components/Weflix/Hedaer.vue"
import Footer from '@/components/Weflix/Footer.vue'
import Subscribe from '@/components/Weflix/Subscribe.vue'
import Login from '@/components/Weflix/Login.vue'
import ApiWebsite from '@/utils/Weflix/Website/index';
import ApiSite from '@/utils/Weflix/Website/index';
import ApiCollections from '@/utils/Weflix/collections';
import ApiPlans from '@/utils/Weflix/Website/plans';
import Banner from "@/components/Weflix/Banner.vue"

import { mapState, mapActions } from 'vuex';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default {
    data(){
        return{
            titleCollection:['Primeire Coleção', 'Segunda Coleção', 'Terceira Coleção'],
            openDialogLogin:false,
            openDialogSubscribe:false,
            collections: [],
            allCollections: [], 
            baseUrl: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_URL_HOMOLOGATION  : window.location.origin,
            currentPage: 1,
            totalPages: 1,
            loading: true,
            activeTab: 'all',
            showPurchaseModal: false,
            selectedCollection: null,
            urlBand: false,
            collection: {
                lessons: []
            },
            modules: [Navigation, Pagination, Scrollbar, A11y],
            mobile: false
        }
    },
    computed: {
        ...mapState(['finalWebsite', 'userPortalWeflix','plansWeflix','storeHasSinglePurchase','user']),
        filteredCollections() {
            if (this.activeTab === 'all') {
                return this.allCollections;
            } else if (this.activeTab === 'owned') {
                return this.allCollections.filter(collection => collection.owned === 4);
            } else {
                return this.allCollections.filter(collection => collection.owned === 0);
            }
        },
        urlBand(){
            const currentUrl = window.location.href;
            return currentUrl.includes('https://www.arte1play.com.br') || currentUrl.includes('https://bandarte1.weflix.com.br');
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Header,
        Footer,
        Subscribe,
        Login,
        Swiper,
        SwiperSlide,
        Banner
    },
    inject: ['recaptchaLoaded', 'executeRecaptcha'],
    methods:{
        ...mapActions(['storeFinalWebsite','storeItemCheckoutWeflix','storeCollectionCheckout']),
        async getPlans() {
            const aux = this.baseUrl.replace(/\/$/, '');

            const payload = {
                "url": aux
            }
            try {
                const response = await ApiPlans.getPlans(payload);
               
                this.storeHasSinglePurchase({
                    hasSinglePurchase: response.length > 0 ? false : true
                });
            } catch (error) {
                console.error(error);
            }
        },
        GoToPlayer(lesson, collection){
            if(
                (this.userPortalWeflix || this.user) && 
                (
                    (this.userPortalWeflix?.user?.orderStatus == 4 || this.userPortalWeflix?.user?.status == 1) || 
                    (this.user?.orderStatus == 4 || this.user?.status == 1)
                )
            ){
                this.$router.push('/player/'+lesson.id);
            } else {
                this.storeItemCheckoutWeflix({itemCheckoutWeflix: collection});
                this.$router.push('/checkoutweflix');
            }
        },
        async getInfoSite() {
            const aux = this.baseUrl.replace(/\/$/, '');

            const payload = {
                "url": aux
            }
            try {
                const response = await ApiSite.getWebsite(payload);
                this.storeFinalWebsite({
                    finalWebsite: response
                });
            } catch (error) {
                console.error(error);
            }
        },
        formatarTempo(tempo) {
            const horas = Math.floor(tempo / 3600);
            const minutos = Math.floor((tempo % 3600) / 60);
            return `${horas > 0 ? horas + 'h ' : ''} ${minutos > 0 ? minutos + 'min' : ''}`;
        },
        handleCollectionClick(collection) {
                this.goToCollection(collection.url);
        },
        closePurchaseModal() {
            this.showPurchaseModal = false;
            this.selectedCollection = null;
        },
        redirectToCheckout(collection) {
                this.storeCollectionCheckout({collectionCheckout: collection});
                this.$router.push('/checkout-collection-weflix');
        },
        setActiveTab(tab) {
            this.activeTab = tab;
            this.currentPage = 1;
        },
        goToVideo(){
            this.openDialogSubscribe = !this.openDialogSubscribe;
        },
        async getCollections(page = 0){
            this.loading = true;
            let aux;
            if(process.env.NODE_ENV === 'development'){
                aux = this.baseUrl;
            } else {
                aux = this.baseUrl.split('/colecoes')[0];
            }
            let payload = {
                "url": aux
            }
            try {
                const response = await ApiWebsite.getCollectionsLimit(payload, page);
                const sortedContent = response.content.sort((a, b) => {
                    // Garante que order seja um número e ordena de forma crescente
                    const orderA = Number(a.order) || 0;
                    const orderB = Number(b.order) || 0;
                    if (orderA > orderB) return 1;
                    if (orderA < orderB) return -1;
                    return 0;
                });
                
                if (page === 0) {
                    this.allCollections = sortedContent;
                } else {
                    this.allCollections = sortedContent;
                }
                
                this.totalPages = response.totalPages;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        async getCollectionByLogin(page = 0){
            this.loading = true;
            try {
                const response = await ApiCollections.getCollectionByLogin(this.userPortalWeflix.acessToken, page);
                const sortedContent = response.content.sort((a, b) => {
                    const orderA = Number(a.order) || 0;
                    const orderB = Number(b.order) || 0;
                    if (orderA > orderB) return 1;
                    if (orderA < orderB) return -1;
                    return 0;
                });

                this.allCollections = sortedContent;
                this.totalPages = response.totalPages;
                console.debug(this.allCollections);
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        goToCollection(id){
            this.$router.push(`/videos-colecao/${id}`);
        },
        async previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                if (this.userPortalWeflix && this.plansWeflix.length == 0) {
                    await this.getCollectionByLogin(this.currentPage - 1);
                } else {
                    await this.getCollections(this.currentPage - 1);
                }
            }
        },
        async nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                if (this.userPortalWeflix && this.plansWeflix.length == 0) {
                    await this.getCollectionByLogin(this.currentPage - 1);
                } else {
                    await this.getCollections(this.currentPage - 1);
                }
            }
        },
        
    },
    created(){
        console.log('Planos',this.plansWeflix.length);
        this.mobile = window.innerWidth <= 768;

        if(this.userPortalWeflix && this.plansWeflix.length == 0){
            this.getCollectionByLogin();
        } else {
            this.getCollections();
        }
        this.getInfoSite();
    }   
}
</script>

<style scoped>
.purchase-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #282828;
    padding: 30px;
    border-radius: 10px;
    width: 90%;
    max-width: 400px;
    text-align: center;
}

.modal-content h3 {
    color: white;
    margin-bottom: 15px;
    font-size: 24px;
}

.modal-content p {
    color: #a4a4a4;
    margin-bottom: 25px;
    font-size: 16px;
}

.modal-buttons {
    display: flex;
    gap: 15px;
    justify-content: center;
}

.modal-buttons button {
    padding: 12px 25px;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.cancel-button {
    background-color: #464646;
    color: white;
}

.buy-button {
    background-color: v-bind('finalWebsite?.color');
    color: white;
}

.cancel-button:hover,
.buy-button:hover {
    filter: brightness(1.1);
    transform: translateY(-1px);
}

/* Novos estilos para as tabs */
.collection-tabs {
    display: flex;
    gap: 20px;
    margin: 20px 0;
}

.tab-button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: #464646;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
}

.tab-button.active {
    background-color: v-bind('finalWebsite?.color');
}

.tab-button:hover {
    filter: brightness(1.1);
}

/* Resto dos estilos mantidos... */
section.collections .titleCollectionsPage, .layout-netflix{
    position: relative;
    transform: translateY(-300px);
    z-index: 999;
}

.title-header {
    position: relative;
    margin-bottom: 30px;
}

.title-content {
    text-align: left;
    margin-top: 50px;
}

.title-content h3 {
    font-size: 32px;
    margin-bottom: 10px;
    color: white;
    font-weight: 700;
}

.title-content p {
    font-size: 16px;
    color: #a4a4a4;
    margin: 0;
}

.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
}

.loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.pagination.site-collections {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    gap: 20px;
}

.pagination-button {
    padding: 8px 16px;
    background-color: #464646;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.pagination-button:hover:not(:disabled) {
    background-color: #5e5e5e;
}

.pagination-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-info {
    color: white;
    font-size: 14px;
}
.loader {
    z-index: 999999;
    position: absolute;
    top: 31%;
}

.cta-single-collection {
    padding: 15px;
    text-align: center;
    background-color: #1e1e1e;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 10px 0px;
}

.price-info {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.price-label {
    color: #a4a4a4;
    font-size: 14px;
}

.price-value {
    color: white;
    font-size: 18px;
    font-weight: bold;
}

.price-details {
    color: #a4a4a4;
    font-size: 14px;
}

.button-single-collection {
    background-color: v-bind('finalWebsite?.color');
    color: white;
    border: none;
    border-radius: 6px;
    padding: 12px 17px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    margin: 0px;
}

.button-single-collection:hover {
    filter: brightness(1.1);
    transform: translateY(-1px);
}

/* Novos estilos para o layout alternativo */
.containerCollectionsAlternative {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 20px;
    max-width: 1500px;
    margin: 0 auto;
}

.itemCollectionAlternative {
    background: #1e1e1e;
    border-radius: 10px;
    overflow: hidden;
    transition: transform 0.3s ease;
}

.itemCollectionAlternative:hover {
    transform: translateY(-5px);
}

.collection-grid {
    display: grid;
    grid-template-columns: 60% 40%;
    gap: 10px;
    padding: 10px;
}

.col-left {
    height: 200px;
}

.col-left .main-image {
    height: 100%;
}

.col-left img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
}

.col-right {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.col-right .secondary-image {
    height: calc(50% - 5px);
        position: relative;
}

.col-right img {
    width: 100%;
    height: 95px !important;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
}

.collectionInfo {
    padding: 15px;
    text-align: left;
}

.collectionInfo h4 {
    color: white;
    margin: 0 0 10px 0;
    font-size: 13px;
}

.collectionInfo .description {
    color: #a4a4a4;
    font-size: 14px;
    margin: 0 0 10px 0;
}

.collectionInfo .videoCount {
    color: white;
    font-size: 12px;
    background: #272727;
    display: inline-block;
    padding: 5px 10px;
    border-radius: 5px;
}

@media (max-width: 768px) {
    section.collections .titleCollectionsPage, .layout-netflix{
        position: relative;
        transform: translateY(50px);
        z-index: 2;
    }
    .containerCollectionsAlternative {
        grid-template-columns: 1fr;
    }
    .tab-button {
        padding: 10px!important;
        height: auto!important;
        font-size: 12px!important;
    }
    button.btn-collection {
        min-width: 110px;
        padding: 7px;
        font-size: 11px;
    }
}

/* Restante dos estilos... */
.carousel__item {
    position: relative;
    cursor: pointer;
}
.carousel__item img {
    width: 98%;
}
.containerCollections .itensCollections {
    padding: 5px 5px 0 5px;
    cursor: pointer;
    width: 100%;
    border-radius: 10px;
    transition: all .5s ease-in-out;
    margin: 0;
    position: relative;
}

@media (min-width: 1200px) {
    
    section.collections .titleCollectionsPage, .layout-netflix{
        position: relative;
        transform: translateY(-200px);
        z-index: 999;
        padding: 4%;
        padding-bottom: 0px;
    }
}
@media (max-width: 1200px) {
    .containerCollections .itensCollections {
        width: 32%;
    }
    section.collections .titleCollectionsPage, .layout-netflix{
        position: relative;
        transform: translateY(-200px);
        z-index: 999;
        padding: 4%;
    }
    .info_header_collections {
        width: 75%;
    }
}

@media (max-width: 768px) {
    .containerCollections .itensCollections {
        width: 48%;
    }
    section.collections .titleCollectionsPage, .layout-netflix{
        transform: translateY(-100px);
       
    }
}

@media (max-width: 480px) {
    .containerCollections .itensCollections {
        width: 100%;
    }
}
.titleCollections {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    color: white;
}
.titleCollectionsPage{
    max-width: 1500px;
    margin: 0 auto;
}
.collections {
    background-color: black!important;
    padding: 20px 0px 50px 0px;
}
.titleCollections h3 {
    font-size: 20px;
    font-weight: 700;
}
.carousel__prev {
    left: -4%;
}
.carousel__next {
    right: -4%;
}
svg.carousel__icon {
    color: white;
}
svg.svg-inline--fa.fa-lock.lockIcon path {
    fill: transparent;
    stroke: white;
    stroke-width: 25px;
}
svg.svg-inline--fa.fa-lock.lockIcon {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 15px;
}
.degradeCarousel__item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #0000007d;
    height: 100%;
    opacity: 0;
    
}
.carousel__item:hover > .degradeCarousel__item {
    opacity: 1;
}
span.textPrivateVideo {
    color: white;
    font-size: 11px;
    position: absolute;
    right: 36px;
    top: 13px;
    opacity: 0;
    transition: all 500ms linear;
    z-index: 2;
}
.carousel__item:hover > span.textPrivateVideo {
    opacity: 1;
}
.descriptionVideo small, .descriptionVideo h4 {
    color: white;
}
.descriptionVideo h4 {
    font-size: 15px;
    margin-left: 5px;
    margin-top: 10px;
    margin-bottom: 0;
}
.descriptionVideo small {
    font-size: 12px;
    margin-left: 5px;
}
.titleCollectionsPage h3 {
    color: white !important;
    font-weight: 700;
}
footer {
    margin-top: 100px !important;
}
.videoCollections img {
    width: 100%;
    height: 300px;
    border-radius: 10px;
}
@media (max-width: 600px) {
    small.description-collections {
        display: none;
    }
    .itensCollections {
        padding: 20px;
    }
    .titleCollectionsPage {
        margin-left: 20px;
    }
    .containerCollections {
        display: block!important;
        gap: 18px;
        flex-wrap: wrap;
        padding: 20px;
        justify-content: start;
    }
    .containerCollections .itensCollections {
        width: 100%;
        margin: 10px 0px!important;
    }
    .videoCollections {
        transition: all 500ms linear;
    }
  
    .itensCollections {
        cursor: pointer;
        width: 100%;
        padding: 15px!important;
    }
}
.containerCollections {
    display: grid !important;
    grid-template-columns: repeat(4, 1fr) !important;
    gap: 60px 10px !important;
    max-width: 1500px !important;
    margin: 0 auto !important;
}
.videoCollections {
    transition: all 500ms linear;
}

.conteriner-flex-videos {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}
.col-1-videos {
    width: 100%!important;
}
.col-2-videos {
    width: 31%;
}
.col-1-videos img {
    width: 100%;
    border-radius: 10px;
    height: auto!important;
}
.col-2-videos img {
    width: 100%;
    border-radius: 10px;
    height: 95px;
}
.row-1-videos {
    margin-bottom: 10px;
}
.row-3-videos {
    width: 100%;
}
.title-row-3-videos {
    text-align: left;
    padding: 0px 8px;
}
.title-row-3-videos h3 {
    color: white !important;
    font-size: 13px;
    margin: 0;
    font-weight: 600;
}
.title-row-3-videos p {
    color: #a4a4a4;
    font-size: 11px;
    margin: 0;
}
.row-2-videos {
    position: relative;
}
.infoVideosBackground {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #393939b8;
    display: flex;
    align-items: center;
    justify-content: center;
}
.infoVideosBackground span {
    color: white;
}
button.btn-voltar {
    padding: 8px 15px;
    position: absolute;
    top: -45px;
    left: 0;
    color: white !important;
    background: none;
    border: none;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
}
button.btn-voltar svg {
    color: white !important;
}

.degradeCarousel__item__collection {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #ff8181;
    height: 100%;
    opacity: 1;
    background: rgb(3, 3, 3);
    background: linear-gradient(0deg, rgb(28 28 28 / 68%) 10%, rgb(50 50 50 / 13%) 40%, rgb(57 45 45 / 0%) 100%);
}
.title-row-3-videos {
    text-align: left;
    padding: 0px 8px;
    position: absolute;
    bottom: 0;
    z-index: 4;
    bottom: 10px;
}
#line1 {
    position: absolute;
    top: 14px;
    height: 5px;
    width: 90%;
    background-color: #ffffff;
    left: 0;
    z-index: 1!important;
    margin: 0 auto;
    left: 50%;
    transform: scale(1.5);
    position: absolute;
    top: -3px!important;
    height: 5px;
    width: 90%;
    background-color: #ffffffa6;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px 10px 0px 0px;
    transition: all 500ms linear;
}
#line2 {
    position: absolute;
    top: 14px;
    height: 5px;
    width: 90%;
    background-color: #ffffff;
    left: 0;
    z-index: 1;
    margin: 0 auto;
    left: 50%;
    transform: scale(1.5);
    position: absolute;
    top: -11px!important;
    height: 5px;
    width: 84%;
    background-color: #ffffff69;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px 10px 0px 0px;
    transition: all 500ms linear;
}
.total-videos {
    position: absolute;
    top: 12px;
    right: 10px;
    background-color: #272727;
    padding: 5px;
    border-radius: 5px;
    color: white;
    font-size: 10px;
}
.col-right img {
    height: 95px !important;
        filter: brightness(0.7);
}   
.videoCount {
    position: absolute;
    bottom: -9%;
    color: #fefefea8;
    font-size: 12px;
    left: 50%;
    transform: translate(-50%, -43%);
    width: 100%;
    background-color: #00000070;
}
.videoCollections.pageCollections img {
    height: auto !important;
}
.titleCollections.pageCollections{
    text-align: left;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
}
.sampleFlag {
    background-color: v-bind('finalWebsite?.color');
    padding: 5px;
    border-radius: 5px;
    color: white;
    font-size: 10px;
    top: 25px !important;
    right: 10px !important;
    position: absolute !important;
    bottom: auto !important;
}
.swiper-button-prev:after, .swiper-button-next:after {
    font-family: swiper-icons;
    font-size: var(--swiper-navigation-size);
    text-transform: none !important;
    letter-spacing: 0;
    font-variant: initial;
    line-height: 1;
    font-size: 24px;
    font-weight: bold;
    /* box-shadow: 0px 0px 10px 1px #ffffff; */
}
.gif-indicator {
    opacity: 0;
    transform: translateY(150px)!important;
    margin: 0 !important;
    transition: all 0.3s ease-in-out!important;
    display: none;
    transition: all 1s ease-in-out!important;
    }
.thumbnail {
    margin: 0 !important;
    transition: all 0.5s ease-in-out!important;
}
.carousel__item {
    position: relative;
    width: 100%;
    height: 100%;
}
.carousel__item:hover .gif-indicator {
    display: block;
    transform: translateY(0px)!important;
    transform: scale(1.2)!important;
    filter: brightness(3)!important;
    opacity: 1!important;
    height: 130px !important;
}
.videoCollections.pageCollections:hover .carousel__item:not(:hover) .thumbnail {
    filter: brightness(0.5)!important;
}
/* .carousel__item:hover .thumbnail {
    display: none;
    opacity: 0;
} */
.videoCollections.pageCollections img.thumbnail {
    height: 130px !important;
}
.collections.view .contentBanner {
    position: absolute;
    width: 100%;
    z-index: 11;
    top: 20%;
    left: 5%;
    text-align: left;
    max-width: 40%;
}
</style>
<style>
.swiper-button-next:after, .swiper-rtl .swiper-button-prev:after, .swiper-button-prev:after, .swiper-button-next:after {
    content: 'next';
    font-size: 20px;
    color: white;
}
.swiper-button-prev:after, .swiper-rtl .swiper-button-next:after {
    content: 'prev';
    font-size: 20px;
    color: white;
}
.info_header_collections p {
    margin-bottom: 0px;
    font-size: 13px;
}
.info_header_collections{
    width: 80%;
}
.button-header-collections {
    display: flex;
}
.btn-collection:first-child {
    background-color: transparent;
    border: 1px solid #434343a8;
    color: #ffffff;
}
.titleVideoCollections h3 {
    font-size: 12px;
    color: white;
    margin: 5px 5px;
    transition: all 0.3s ease-in-out;
}
.titleVideoCollections h3:hover {
    color: #ffffffa8;
}
.carousel__item:hover h3 {
    transform: translateY(2px);
    font-size: 13px;
    z-index: 9999;
}
.pagination.site-collections {
    transform: translateY(-100px);
}
.info_header_collections h5 {
    font-size: 15px;
    color: gray;
}
@media screen and (max-width: 768px) {
    .titleCollections.pageCollections.titleCollectionMobile {
        display: block !important;
    }
    .titleCollections.pageCollections.titleCollectionMobile .info_header_collections {
        width: 100%;
    }
    .titleCollections.pageCollections.titleCollectionMobile .info_header_collections h3 {
        font-size: 14px;
    }
    .button-header-collections {
        margin-top: 12px;
        gap: 10px;
    }
    .titleCollections.pageCollections.titleCollectionMobile .btn-collection{
        background-color: transparent;
        border: 1px solid #434343a8;
        color: #ffffff;
    }
}
</style>